export default function ReturnOrderMenuIcon(props) {
  return (
    <svg
      viewBox="-2 -2 28 28"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.8994 2.5C19.4492 2.50009 19.92 2.69541 20.3115 3.08691C20.7032 3.47858 20.8994 3.95 20.8994 4.5V11.584C20.5745 11.5295 20.2408 11.5 19.9004 11.5C19.5594 11.5 19.2249 11.5293 18.8994 11.584V4.5H15.8994V12.5L11.8994 10.5L7.89941 12.5V4.5H4.89941V18.5H13.9844C14.1049 19.2181 14.3526 19.8925 14.7041 20.5H4.89941C4.34941 20.5 3.87799 20.3038 3.48633 19.9121C3.09482 19.5206 2.8995 19.0498 2.89941 18.5V4.5C2.89941 3.95 3.09466 3.47858 3.48633 3.08691C3.87799 2.69526 4.34942 2.5 4.89941 2.5H18.8994ZM11.8994 16.5H6.89941V14.5H11.8994V16.5ZM9.89941 9.25L11.8994 8.25L13.8994 9.25V4.5H9.89941V9.25Z"
        fill="currentColor"
      />
      <path
        d="M21.2994 14.9L19.8994 13.5L15.8994 17.5L19.8994 21.5L21.3244 20.1L19.7244 18.5L23.8994 18.5L23.8994 16.5L19.7244 16.5L21.2994 14.9Z"
        fill="currentColor"
      />
    </svg>
  );
}
